import worldLabels from './de-world.json' with { type: 'json' }

// Reviewed UI language and corrections to machine-translated world names.
// Game state continues to use stable English identifiers; this is display-only.
const reviewed:Record<string,string>={
  'POWERED BY':'PRÄSENTIERT VON',
  'YOUR WORLD':'DEINE WELT',
  'A little head start':'Ein kleiner Vorsprung',
  '25 rolls are waiting.':'25 Würfe warten auf dich.',
  'Welcome gift collected.':'Willkommensgeschenk abgeholt.',
  'Open rewards →':'Belohnungen öffnen →',
  'City Explorer':'Stadtentdecker',
  'Sign in to save':'Anmelden zum Speichern',
  'Administrator':'Administrator',
  'Account connected':'Konto verbunden',
  'Rank {rank}':'Rang {rank}',
  'Sign in':'Anmelden',
  'Open account':'Konto öffnen',
  'Mute game':'Spiel stummschalten',
  'Unmute game':'Spielton einschalten',
  'Play':'Spielen',
  'Mute game audio':'Spielton stummschalten',
  'Unmute game audio':'Spielton einschalten',
  'Mute Lucky Estates music and sound effects only':'Nur Musik und Effekte von Lucky Estates stummschalten',
  'Next goal · Improve {landmark}':'Nächstes Ziel · {landmark} ausbauen',
  'Next goal · Begin the next district':'Nächstes Ziel · Nächsten Bezirk beginnen',
  'Build your city, one lucky block at a time.':'Baue deine Stadt, Block für Block.',
  'My city':'Meine Stadt',
  'MY CITY':'MEINE STADT',
  'More':'Mehr',
  'MORE':'MEHR',
  'Players':'Spieler',
  'Play with {language} opponents':'Spiele gegen Gegner auf {language}',
  'Challenge controls':'Herausforderung steuern',
  'Edition':'Ausgabe',
  'City coins':'Stadtmünzen',
  'Regular game rolls remaining':'Verbleibende Würfe im regulären Spiel',
  'Saving…':'Speichern…',
  'Settings':'Einstellungen',
  'Rewards':'Belohnungen',
  'Album':'Album',
  'Journey':'Reise',
  'Showroom':'Ausstellung',
  'Shop':'Shop',
  'What would you like to do?':'Was möchtest du tun?',
  'Daily gifts, Quick Wins, and city tasks':'Tägliche Geschenke, schnelle Erfolge und Stadtaufgaben',
  'Collect city stories and finish sets':'Stadtgeschichten sammeln und Sammlungen vervollständigen',
  'Travel through your city districts':'Reise durch deine Stadtviertel',
  'Choose pieces, dice, and shields':'Figuren, Würfel und Schilde auswählen',
  'Ten-turn challenges with AI competitors':'Herausforderungen mit KI-Gegnern über zehn Runden',
  'Roll and coin offers':'Angebote für Würfe und Münzen',
  'Language, audio, picture, world, and account':'Sprache, Ton, Bild, Welt und Konto',
  'READY TO COLLECT':'BEREIT ZUM ABHOLEN',
  'Your rewards':'Deine Belohnungen',
  '25 rolls, on the house.':'25 Würfe als Geschenk.',
  'Collected':'Abgeholt',
  'Collect 25 rolls':'25 Würfe abholen',
  'Weekend wanderer':'Wochenendentdecker',
  'Complete five turns to earn 50,000 coins.':'Schließe fünf Züge ab und verdiene 50.000 Münzen.',
  '{count} / 5 turns':'{count} / 5 Züge',
  'Quick Wins':'Schnelle Erfolge',
  'Roll, build, and collect to fill today’s progress.':'Würfle, baue und sammle für deinen heutigen Fortschritt.',
  '{city} STORIES':'GESCHICHTEN AUS {city}',
  'Your postcard album':'Dein Postkartenalbum',
  'Find on the board':'Auf dem Spielbrett finden',
  'DISTRICT MAP':'BEZIRKSKARTE',
  'Your {city} journey':'Deine Reise durch {city}',
  'Complete District 1':'Bezirk 1 abschließen',
  'Locked':'Gesperrt',
  'YOUR COLLECTION':'DEINE SAMMLUNG',
  'Choose a game piece':'Wähle eine Spielfigur',
  'Equipped':'Ausgerüstet',
  'Choose':'Auswählen',
  'CITY SHOP':'STADTSHOP',
  'Keep exploring':'Weiter erkunden',
  'Review mode: these offers add demo currency and do not charge a payment.':'Vorschaumodus: Diese Angebote fügen Demowährung hinzu, ohne eine Zahlung auszulösen.',
  '{count} rolls':'{count} Würfe',
  '+{count} first offer':'+{count} beim ersten Angebot',
  'Across Manhattan, over the East River, down to the harbor.':'Von Manhattan über den East River bis zum Hafen.',
  'My city. Up close.':'Deine Stadt. Ganz nah.',
  'Your city. Up close.':'Deine Stadt. Ganz nah.',
  'Your next move.':'Dein nächster Zug.',
  'Your next':'Dein nächster',
  'move.':'Zug.',
  'Your city':'Deine Stadt',
  'YOUR CITY':'DEINE STADT',
  'YOUR CHALLENGE CITY':'DEINE HERAUSFORDERUNGSSTADT',
  'YOUR LATEST MOVE':'DEIN LETZTER ZUG',
  'Your properties':'Deine Grundstücke',
  'Each address is part of your {city} skyline.':'Jede Adresse gehört zur Skyline von {city}.',
  'LANDMARKS':'WAHRZEICHEN',
  'NEIGHBORHOOD PROPERTIES':'GRUNDSTÜCKE IM VIERTEL',
  'Choose a property to visit':'Wähle ein Grundstück aus',
  'Choose a property to visit.':'Wähle ein Grundstück aus.',
  'Across {city}':'{city} entdecken',
  'Entire city':'Ganze Stadt',
  '⌗ Entire city':'⌗ Ganze Stadt',
  'Level {level} / 3':'Stufe {level} / 3',
  '{count} houses':'{count} Häuser',
  'Hotel':'Hotel',
  'Ready to develop':'Bereit zum Bebauen',
  'Landmark complete':'Wahrzeichen fertig',
  '{coins} coins · Earn one house':'{coins} Münzen · Ein Haus verdienen',
  'Complete':'Fertig',
  'More coins needed':'Mehr Münzen nötig',
  '⚒ Improve':'⚒ Ausbauen',
  'Drag to rotate · Select a landmark or property to visit':'Ziehen zum Drehen · Wahrzeichen oder Grundstück auswählen',
  'Select an address to fly closer. Improve landmarks to grow your skyline.':'Wähle eine Adresse für die Nahansicht. Baue Wahrzeichen aus, damit deine Skyline wächst.',
  'Explore your {city} properties':'Grundstücke in {city} erkunden',
  '3D graphics unavailable':'3D-Grafik nicht verfügbar',
  'Enable browser hardware acceleration and reload to explore your city.':'Aktiviere die Hardwarebeschleunigung im Browser und lade die Seite neu.',
  'Your city needs 3D graphics':'Für deine Stadt ist 3D-Grafik erforderlich',
  'Enable hardware acceleration in your browser, then reload to explore {city}.':'Aktiviere die Hardwarebeschleunigung im Browser und lade neu, um {city} zu erkunden.',
  'Reload city':'Stadt neu laden',
  'Explore {city} game board':'Spielbrett von {city} erkunden',
  'View entire board':'Gesamtes Spielbrett anzeigen',
  'Follow my piece':'Spielfigur folgen',
  '⌗ Overview':'⌗ Übersicht',
  '↗ Follow piece':'↗ Figur folgen',
  'Zoom in':'Vergrößern',
  'Zoom out':'Verkleinern',
  'Zoom in city':'Stadt vergrößern',
  'Zoom out city':'Stadt verkleinern',
  'Rolling dice':'Würfel rollen',
  'Roll the dice':'Würfeln',
  'Rolling the dice…':'Würfel rollen…',
  'Rolled {a} + {b} · {spaces} spaces':'Gewürfelt: {a} + {b} · {spaces} Felder',
  'Your district is complete':'Dein Bezirk ist fertig',
  'Rolls remaining in your regular game.':'Verbleibende Würfe im regulären Spiel.',
  'Open the roll shop.':'Würfelshop öffnen.',
  'Buy more rolls':'Mehr Würfe kaufen',
  'Drag to explore your neighborhood':'Ziehen, um dein Viertel zu erkunden',
  'Improve {landmark} for {coins} coins.':'Baue {landmark} für {coins} Münzen aus.',
  'Your district is complete. Explore what comes next.':'Dein Bezirk ist fertig. Entdecke, was als Nächstes kommt.',
  'Last dice: {a} and {b}':'Letzte Würfel: {a} und {b}',
  '{count} / 15 upgrades':'{count} / 15 Ausbauten',
  'Open challenge city ↗':'Herausforderungsstadt öffnen ↗',
  'Open My City ↗':'Meine Stadt öffnen ↗',
  'Browse all 40 spaces':'Alle 40 Felder ansehen',
  'Inspect board space':'Spielfeld ansehen',
  'City property':'Stadtgrundstück',
  'Property group {group} · {houses} houses':'Farbgruppe {group} · {houses} Häuser',
  'DISTRICT {district}':'BEZIRK {district}',
  'COLLECT 2,000':'2.000 MÜNZEN',
  'EACH LAP':'PRO RUNDE',
  'LUCKY ESTATES':'LUCKY ESTATES',
  'YOUR NEXT MOVE':'DEIN NÄCHSTER ZUG',
  'WELCOME':'WILLKOMMEN',
  'SHIELD':'SCHILD',
  'SURPRISE':'ÜBERRASCHUNG',
  'POSTCARD':'POSTKARTE',
  'TRANSIT':'NAHVERKEHR',
  'CITY TAX':'STADTSTEUER',
  'CITY PARK':'STADTPARK',
  'FESTIVAL':'FESTIVAL',
  'CANAL PORT':'KANALHAFEN',
  'TIDE FESTIVAL':'GEZEITENFEST',
  'Palace of the Tides':'Palast der Gezeiten',
  'ATLANTIC SEABED · OCEANA':'ATLANTISCHER MEERESBODEN · OCEANA',
  'MID ATLANTIC RIDGE':'MITTELATLANTISCHER RÜCKEN',
  'BERMUDA RISE':'BERMUDA-RÜCKEN',
  'ROMANCHE TRENCH':'ROMANCHE-GRABEN',
  'WALVIS RIDGE':'WALVISRÜCKEN',
  'RIO GRANDE RISE':'RIO-GRANDE-RÜCKEN',
  'Interactive 3D {city} neighborhood and 40-space Lucky Estates board. Drag to look around; use the zoom controls to explore.':'Interaktives 3D-Viertel in {city} mit 40 Spielfeldern. Ziehen, um dich umzusehen; mit den Tasten zoomen.',
  'Interactive 3D {city}. Select a landmark or property to visit it.':'Interaktive 3D-Stadt {city}. Wähle ein Wahrzeichen oder Grundstück aus.',
  'United States':'Vereinigte Staaten',
  'Mexico':'Mexiko',
  'France':'Frankreich',
  'Germany':'Deutschland',
  'Russia':'Russland',
  'Italy':'Italien',
  'China':'China',
  'South Korea':'Südkorea',
  'Japan':'Japan',
  'Brazil':'Brasilien',
  'India':'Indien',
  'Indonesia':'Indonesien',
  'Vietnam':'Vietnam',
  'Moon':'Mond',
  'Mars':'Mars',
  'Spain':'Spanien',
  'An imagined Atlantic city beneath glass: pearl towers, bronze colonnades and stepped palaces between blue canals where dolphins, sharks and whales swim.':'Eine fantastische Atlantikstadt unter Glas: Perlentürme, bronzene Säulenhallen und gestufte Paläste zwischen blauen Kanälen. Hier schwimmen Delfine, Haie und Wale.',
  '3D worlds':'3D-Welten',
  'Choose a city to explore. Your progress travels with you.':'Wähle eine Stadt zum Erkunden. Dein Fortschritt reist mit.',
  '{ready} of {total} ready':'{ready} von {total} bereit',
  'Selected':'Ausgewählt',
  'Explore':'Erkunden',
  'Coming soon':'Demnächst',
  'Explore {city}':'{city} erkunden',
  '{city} is coming soon':'{city} erscheint bald',
  'PREFERENCES':'EINSTELLUNGEN',
  'Game picture':'Spielfigur',
  'Parkside Builder':'Parkbauer',
  'Coral Founder':'Korallengründer',
  'Jade Architect':'Jadearchitekt',
  'Saffron Host':'Safrangastgeber',
  'Golden Developer':'Goldener Bauherr',
  'Lavender Designer':'Lavendelgestalter',
  'Teal Patron':'Türkisfarbener Mäzen',
  'Skyline Founder':'Skyline-Gründer',
  'Ochre Restaurateur':'Ockerfarbener Gastronom',
  'Coral Hotelier':'Korallenhotelier',
  'Silver Producer':'Silberproduzent',
  'Marigold Investor':'Ringelblumen-Investor',
  'Harbor Entrepreneur':'Hafenunternehmer',
  'Copper Curator':'Kupferkurator',
  'Rose Executive':'Rosenmanagerin',
  'Grand Hotelier':'Grandhotelier',
  'Emerald Architect':'Smaragdarchitekt',
  'Cobalt Director':'Kobaltdirektor',
  'Sunshine Musician':'Sonnenscheinmusiker',
  'Plum Philanthropist':'Pflaumen-Philanthrop',
  'Bicycle':'Fahrrad',
  'Race car':'Rennwagen',
  'Sailboat':'Segelboot',
  'Airplane':'Flugzeug',
  'Native language':'Muttersprache',
  'Game audio':'Spielton',
  'Background music':'Hintergrundmusik',
  'Reduce motion':'Animationen reduzieren',
  'Pause decorative traffic and building motion.':'Dekorativen Verkehr und Gebäudeanimationen pausieren.',
  'Mute Lucky Estates music and sound effects. Your computer volume stays unchanged.':'Musik und Effekte von Lucky Estates stummschalten. Die Lautstärke deines Computers bleibt unverändert.',
  'The six original New York game tracks rotate in every city.':'Die sechs ursprünglichen New-York-Spielstücke laufen abwechselnd in jeder Stadt.',
}

export function germanText(text:string):string|undefined {
  return reviewed[text]??(worldLabels as Record<string,string>)[text]
}
